import graphVrifyCode from "@/common/components/graph-vrifyCode/" // 图形验证码
import GDialog from "@/common/components/g-dialog/" // 弹框
import GHeader from '@/common/components/g-header/' // 头部
import refreshAcount from '@/common/components/refreshAcount/' // 刷新账户
import linksBanner from '@/common/components/links-banner/'
import noData from '@/common/components/noData/'
import loadMore from '@/common/components/load-more/'
import GCertificate from '@/common/components/g-certificate/'
import GTab from '@/common/components/g-tab/'
import imgCodeWrap from '@/common/components/img-code-wrap/'
import GButton from '@/common/components/g-button/'


function plugin(Vue) {
	if (plugin.installed) {
		return
	}
	Vue.component('g-header', GHeader)
  Vue.component('g-vrifycode', graphVrifyCode)
  Vue.component('g-dialog', GDialog)
  Vue.component('refresh-acount', refreshAcount)
  Vue.component('links-banner', linksBanner)
  Vue.component('img-code-wrap', imgCodeWrap)
  Vue.component('no-data', noData)
  Vue.component('load-more', loadMore)
  Vue.component('g-certificate', GCertificate)
  Vue.component('g-tab', GTab)
  Vue.component('g-button', GButton)
}

export default plugin



// WEBPACK FOOTER //
// ./src/pages/build902/utils/globalComponent.js